import React from 'react';
import { Row, Col } from 'antd';
import { isNil } from 'lodash';

import {
  AssignmentAdditionalInfoModel,
  AssignmentInfoUserResponseModel,
  AssignmentTypeEnum,
} from 'api/backofficeApiClient';
import {
  MemberQuestionnaireSection,
  ClassificationQuestionnaireSection,
} from 'features/assignment/Questionnaire/QuestionnaireSections';
import DownloadAssignment from '../DownloadAssignment';
import BasePageCard from 'components/wrappers/BasePageCard';
import BasePageLabel from 'components/wrappers/BasePageLabel';
import { getAssignmentPageIdLabel } from 'utils/assignmentUtils';
import RenewAssignment from 'features/assignment/RenewAssignment';
import AssignmentAdditionalInfoCard from './AssignmentAdditionalInfoCard';

type Props = {
  loadAssignmentDetails: () => Promise<void>;
  assignmentPrimaryDetails: AssignmentInfoUserResponseModel;
  assignmentAdditionalDetails: AssignmentAdditionalInfoModel;
};

export default function AssignmentAdditionalInfoSection(props: Props) {
  const {
    assignmentPrimaryDetails,
    assignmentAdditionalDetails,
    loadAssignmentDetails,
  } = props;

  const {
    assignmentKey,
    assignmentType,
    assignmentStatus,
    renewStatus,
    assignmentId,
    creator,
  } = assignmentPrimaryDetails;

  const { additionalInfo, contractorQuestionnaire, memberQuestionnaire } =
    assignmentAdditionalDetails;

  const isAdditionalInfo =
    !isNil(additionalInfo?.anticipatedWeeklyCommission) ||
    !isNil(additionalInfo?.confirmationCommissionStructure) ||
    !isNil(additionalInfo?.grossMarginPerHour) ||
    !isNil(additionalInfo?.grossMarginPercent) ||
    !isNil(additionalInfo?.markup);

  const pageLabel = getAssignmentPageIdLabel({
    assignmentStatus,
    renewStatus,
  });

  return (
    <>
      {pageLabel && <BasePageLabel label={pageLabel} creator={creator} />}

      <div className="page-box page-inner">
        <div className="page-inner-container">
          <div className="page-head">
            <div className="page-head__left">
              <div className="page-title page-head__title">{assignmentKey}</div>
            </div>
            <div className="page-head__actions">
              <div>
                <RenewAssignment
                  assignmentDetails={assignmentPrimaryDetails}
                  loadAssignmentDetails={loadAssignmentDetails}
                />
              </div>

              <div>
                <DownloadAssignment
                  assignmentId={assignmentId}
                  assignmentStatus={assignmentStatus}
                />
              </div>
            </div>
          </div>

          {isAdditionalInfo && (
            <Row gutter={[10, 10]}>
              <Col xs={24} md={12}>
                <BasePageCard
                  title="Additional information"
                  icons={<span className="icon icon-additional"></span>}
                >
                  <div className="content-wrapper">
                    {additionalInfo && (
                      <AssignmentAdditionalInfoCard
                        additionalInfo={additionalInfo}
                      />
                    )}
                  </div>
                </BasePageCard>
              </Col>
            </Row>
          )}

          {assignmentType === AssignmentTypeEnum.ICAssignment && (
            <Row gutter={[10, 10]}>
              {memberQuestionnaire && (
                <MemberQuestionnaireSection
                  questionnaireInfo={memberQuestionnaire}
                />
              )}

              {contractorQuestionnaire && (
                <ClassificationQuestionnaireSection
                  questionnaireInfo={contractorQuestionnaire}
                />
              )}
            </Row>
          )}
        </div>
      </div>
    </>
  );
}
